import React from 'react'

const AzureLogo = (): JSX.Element => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 56 44"
      width="70"
      height="70"
      className="azure-logo"
    >
      <g>
        <path
          className="st0"
          d="M25.9,41.1c7.2-1.3,13.1-2.3,13.2-2.3l0.1,0l-6.8-8.1c-3.7-4.4-6.8-8.1-6.8-8.1c0,0,7-19.4,7.1-19.4
		c0,0,4.8,8.2,11.6,20c6.4,11,11.6,20.1,11.6,20.2l0.1,0.2l-21.6,0l-21.6,0C12.8,43.4,25.9,41.1,25.9,41.1z"
        />
        <path
          className="st0"
          d="M0,38.6c0,0,3.2-5.6,7.1-12.3l7.1-12.3l8.3-7c4.6-3.8,8.3-7,8.3-7c0,0,0,0.1-0.1,0.3c-0.1,0.2-4.1,8.9-9,19.3
		l-8.8,19l-6.4,0C2.9,38.6,0,38.6,0,38.6z"
        />
      </g>
    </svg>
  )
}

export default AzureLogo
